import axios from "axios";
import { logout } from "../redux/userSlice";
import { removeSchool } from "../redux/schoolSlice";
import { removeSessions } from "../redux/sessionSlice";
import { store } from "../redux/store";

const getApiUrl = () => {
  // Fallback for local dev
  if (window.location.hostname === "localhost") {
    return process.env.REACT_APP_LOCAL_API_URL;
  }

  // Prefer environment variable if set
  return process.env.REACT_APP_API_URL;
};

const axiosInstance = axios.create({
  baseURL: getApiUrl(),
  withCredentials: true,
});

export async function refreshToken() {
  try {
    await axiosInstance.post("/auth/refresh", {}, { withCredentials: true });
    // console.log("Access token refreshed");
  } catch (err) {
    // console.error("Refresh failed, redirecting to login...");
    const dispatch = store.dispatch;
    logoutUser(dispatch);
  }
}

export async function logoutUser(dispatch) {
  try {
    // Call backend logout to clear HttpOnly cookies
    await axiosInstance.post("/auth/logout", {}, { withCredentials: true });

    // console.log("safe logout");
  } catch (err) {
    // console.error("Server logout failed", err);
  } finally {
    // Always clear Redux state
    dispatch(logout());
    dispatch(removeSchool());
    dispatch(removeSessions());
  }
}
